

















// import "../styles/NewPlant.css";

// export default function NewPlant() {
//   return (
//     <section className="newplant-section">

//       <div className="container">

//         {/* HEADER */}
//         <div className="newplant-header">

//           <h2>New Plant Expansion</h2>

//           <p>
//             Upcoming manufacturing expansion with advanced production lines,
//             modern machinery, and enhanced HVAC capabilities.
//           </p>

//           <div className="launch-badge">
//             🚀 Plant Launch: OCT, 2026
//           </div>

//         </div>

//         {/* GRID */}
//         <div className="newplant-grid">

//           <div className="newplant-card">
//             🏭 Plant built on 5 Acres (New Facility)
//           </div>

//           <div className="newplant-card">
//             ⚙ IDU LCAC Production Line
//           </div>

//           <div className="newplant-card">
//             ❄ ODU LCAC Production Line
//           </div>

//           <div className="newplant-card">
//             🧊 New Refrigeration Line
//           </div>

//           <div className="newplant-card">
//             🔧 Heat Exchanger Lines (7mm, 5mm, 9.52mm)
//           </div>

//           <div className="newplant-card">
//             🔩 Tubing & Header Assembly Line
//           </div>

//           <div className="newplant-card">
//             🧪 Psychrometric Laboratory
//           </div>

//           <div className="newplant-card">
//             🏋 Yangli Press Machines (8 Presses: 400T–63T)
//           </div>

//           <div className="newplant-card">
//             ⚡ New Turret Line (2 Nos)
//           </div>

//           <div className="newplant-card">
//             💡 Laser Cutting Line (1 No)
//           </div>

//           <div className="newplant-card">
//             🛠 CNC Press Brake Machines
//           </div>

//           <div className="newplant-card">
//             🏗 Advanced Automation Production Setup
//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }





















import "../styles/NewPlant.css";

export default function NewPlant() {
  return (
    <section className="newplant-section">

      <div className="container">

        {/* HEADER */}
        <div className="newplant-header">

          <h2>New Plant Expansion</h2>

          <p>
            Upcoming manufacturing expansion with advanced production lines,
            modern machinery, and enhanced HVAC capabilities.
          </p>

          <div className="launch-badge">
            🚀 Plant Launch: OCT, 2026
          </div>

        </div>

        {/* GRID */}
        <div className="newplant-grid">

          <div className="newplant-card">
            <span className="icon">🏭</span>
            <p>Plant built on 5 Acres (New Facility)</p>
          </div>

          <div className="newplant-card">
            <span className="icon">⚙</span>
            <p>IDU LCAC Production Line</p>
          </div>

          <div className="newplant-card">
            <span className="icon">❄</span>
            <p>ODU LCAC Production Line</p>
          </div>

          <div className="newplant-card">
            <span className="icon">🧊</span>
            <p>New Refrigeration Line</p>
          </div>

          <div className="newplant-card">
            <span className="icon">🔧</span>
            <p>Heat Exchanger Lines (7mm, 5mm, 9.52mm)</p>
          </div>

          <div className="newplant-card">
            <span className="icon">🔩</span>
            <p>Tubing & Header Assembly Line</p>
          </div>

          <div className="newplant-card">
            <span className="icon">🧪</span>
            <p>Psychrometric Laboratory</p>
          </div>

          <div className="newplant-card">
            <span className="icon">🏋</span>
            <p>Yangli Press Machines (8 Presses: 400T–63T)</p>
          </div>

          <div className="newplant-card">
            <span className="icon">⚡</span>
            <p>New Turret Line (2 Nos)</p>
          </div>

          <div className="newplant-card">
            <span className="icon">💡</span>
            <p>Laser Cutting Line (1 No)</p>
          </div>

          <div className="newplant-card">
            <span className="icon">🛠</span>
            <p>CNC Press Brake Machines</p>
          </div>

          <div className="newplant-card">
            <span className="icon">🏗</span>
            <p>Advanced Automation Production Setup</p>
          </div>

        </div>

      </div>

    </section>
  );
}
